import { useState, useEffect } from 'preact/hooks';

// eslint-disable-next-line import/prefer-default-export
export function useWindowSize() {
  const [windowSize, setWindowSize] = useState({ width: 0, height: 0 });
  const handleSize = () => {
    setWindowSize({ width: window.innerWidth, height: window.innerHeight });
  };
  useEffect(() => {
    handleSize();
    window.addEventListener('resize', handleSize);
    return () => window.removeEventListener('resize', handleSize);
  }, []);
  return {
    ...windowSize,
    isMobile: windowSize.width < 690,
    isTabletOrSmaller: windowSize.width < 1024,
    isTablet: windowSize.width >= 690 && windowSize.width < 1024,
    isLaptop: windowSize.width >= 1024 && windowSize.width < 1280,
    isDesktop: windowSize.width >= 1280 && windowSize.width < 1400,
    isWide: windowSize.width >= 1400,
  };
}
